import { memo } from 'react';

interface Props {
  time?: string | null | undefined;
  endTime?: string | null | undefined;
}

function EventTime({ time, endTime }: Props) {
  if (!time) {
    return null;
  }

  return <>{`${time}${endTime ? `–${endTime}` : ''}`}</>;
}

export default memo(EventTime);
